import React, { useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import "./Representation.scss";
import "./Responsive.scss";

const Representation = () => {
    const [recaptch, setRecaptcha] = useState("");
    const [hasLicense, setHasLicense] = useState(false);
    const breadCrumbData = [
        { title: "خانه", link: "/" },
        { title: "درخواست نمایندگی", link: "/representation" },
    ];
    const recaptchHandler = (recaptchaValue) => {
        setRecaptcha(recaptchaValue);
    };
    const hasLicenseHandler = () => {
        let licenseTextarea = document.querySelector(".representationForm .formGroup.license");
        if (!hasLicense) {
            setHasLicense(true);
            licenseTextarea.style.display = "block";
        } else {
            setHasLicense(false);
            licenseTextarea.style.display = "none";
        }
    }
    return (
        <section className="representationWrapper mobile">
            <BreadCrumb breadCrumbData={breadCrumbData} />
            <div className="representationContent">
                <div className="desktop">
                    <div className="representationForm">
                        <div className="formHeader">
                            <p className="title">درخواست نمایندگی <span>(برای درخواست نمایندگی مشخصات زیر را کامل کنید)</span></p>
                        </div>
                        <div className="formWrapper">
                            <div className="formGroup sm">
                                <div className="caption">
                                    <input type="text" name="" id="name" placeholder="" />
                                    <span className="placeholder">نام و نام خانوادگی *</span>
                                </div>
                            </div>
                            <div className="formGroup sm">
                                <div className="caption">
                                    <input type="text" name="" id="name" placeholder="" />
                                    <span className="placeholder">شماره تماس *</span>
                                </div>
                            </div>
                            <div className="formGroup sm">
                                <div className="caption">
                                    <input type="text" name="" id="name" placeholder="" />
                                    <span className="placeholder">نام فروشگاه *</span>
                                </div>
                            </div>
                            <div className="formGroup sm">
                                <div className="caption">
                                    <input type="number" min="0" name="" id="name" placeholder="" />
                                    <span className="placeholder">سابقه(سال) *</span>
                                </div>
                            </div>
                            <div className="formGroup">
                                <div className="caption">
                                    <textarea name="" id="message" placeholder=""></textarea>
                                    <span className="placeholder">آدرس *</span>
                                </div>
                            </div>
                            <div className="formGroup">
                                <label className="checkbox">مجوز دارید؟
                                    <input type="checkbox" value={hasLicense} onChange={hasLicenseHandler} />
                                    <span className="checkboxmark"></span>
                                </label>
                            </div>
                            <div className="formGroup license">
                                <div className="caption">
                                    <textarea name="" id="license" placeholder=""></textarea>
                                    <span className="placeholder">توضیحات مجوز *</span>
                                </div>
                            </div>
                            <div className="formGroup">
                                <ReCAPTCHA size="invisible" sitekey="6LfO7RAlAAAAAMcpWRyrmUNJYqmrl64Dp-h9u4Qt" onChange={recaptchHandler} />
                            </div>
                            <div className="formGroup">
                                <button type="submit" className="btnSend">ارسال</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default React.memo(Representation);
